module.exports = __webpack_public_path__ + "img/blazer.ccb072c3.svg";